<template functional>
    <div
        class="o-menu-item menu-item"
        :style="{'background-color': props.item.meta.var_сolor ? `var(${props.item.meta.var_сolor})` : props.item.meta.color}"
        v-on:click="$options.redirect(props.item.meta, props.mode)"
    >  
        <div class="o-menu-item__icon">
            <img :src="props.item.files.menuIcon" alt="menu item">
        </div>
        <div class="o-menu-item__info">
            <div class="o-menu-item__info__title">{{props.item.meta[`name_${props.locale}`]}}</div>
            <div class="o-menu-item__info__subtile">{{props.item.meta[`description_${props.locale}`]}}</div>
        </div>
        <slot name="icon-right">
            <svg-icon
                original
                name="icons/arrow-right"
                class="o-menu-item__icon-right"
            />
        </slot>
    </div>
</template>

<script>
import router from '@/router';
import { bypassFocusTo } from "@/utils/helpers/ios-focus-input-on-click";

export default {
    props: {
        locale: {
            type: String,
            default: "en"
        },
        item: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    redirect(meta, mode) {
        if(meta.linkType === 'route') {
            let stringRoute = JSON.stringify(meta.link);
            const isSearch = stringRoute.includes('search');
            stringRoute = stringRoute.replace('$$platformType$$', mode);
            stringRoute = stringRoute.replace('$$mapId$$', router.currentRoute.params.mapId);

            router.push(JSON.parse(stringRoute));

            isSearch && bypassFocusTo('search__input');

        } else if(meta.linkType === 'external_url') {
            window.open(meta.link,'_blank');
        }
    },
}
</script>

<style lang="scss" src="./o-menu-item.scss" />
